/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon24Regular = forwardRef('ArrowCUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.383 16.119a.875.875 0 0 1 0-1.238L9.79 8.474a3.125 3.125 0 0 1 4.42 0l6.406 6.407a.875.875 0 1 1-1.237 1.238l-6.407-6.407a1.375 1.375 0 0 0-1.945 0l-6.406 6.407a.875.875 0 0 1-1.238 0Z" })));
});
